import { handleApiCall } from "../api";

export const getFilter = (entity: any, store_id?: any) =>
    handleApiCall(
        "get",
        `/filters?entity=${encodeURIComponent(entity)}${store_id ? `&store_id=${encodeURIComponent(String(store_id))}` : ''}`
    );

export const applyFilter = (postPayload) => handleApiCall("post", `/filters`, postPayload)